const faqs = [
  {
    q: '哔咔动漫真的完全免费吗？有没有隐藏收费？',
    a: '是的，哔咔动漫平台上所有漫画内容永久免费，无任何付费墙或章节限制。我们通过广告合作维持运营，用户无需支付任何费用即可畅享全部漫画资源。日漫、韩漫、国漫一视同仁，全部免费下拉阅读。',
  },
  {
    q: '需要注册账号才能阅读漫画吗？',
    a: '不需要！哔咔动漫坚持极简体验，打开网站即可直接阅读，无需注册或登录。当然，如果你想收藏漫画、保存阅读进度或参与社区互动，也可以自愿注册账号获得更完整的个性化服务。',
  },
  {
    q: '漫画更新速度怎么样？热门连载多久能看？',
    a: '我们的汉化团队与海外同步跟进，热门连载通常在官方发布后24-48小时内完成汉化并上线。每日新增超过100个章节，确保追更党第一时间看到最新内容。你可以关注"最新动态"模块获取每日更新信息。',
  },
  {
    q: '手机端阅读体验如何？需要下载APP吗？',
    a: '哔咔动漫采用响应式设计，桌面端和移动端都有优秀的阅读体验。手机端无需下载任何APP，直接用浏览器访问即可享受流畅的下拉式竖屏阅读。我们特别优化了移动端的加载速度和阅读版面，省流量更省心。',
  },
  {
    q: '网站上的漫画画质怎么样？有高清版本吗？',
    a: '哔咔动漫所有漫画均提供高清画质，图片经过专业优化处理，在保证清晰度的同时兼顾加载速度。我们会根据原作质量提供最佳可用的画质版本，确保每一页的细节和文字都清晰可辨。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            关于哔咔动漫的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((f, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <div className="px-6 py-4 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 text-primary-500 flex items-center justify-center text-xs font-bold mt-0.5">
                  Q
                </span>
                <div className="flex-1">
                  <h3 className="text-sm font-semibold text-foreground-900 mb-2">{f.q}</h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}